'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwOnFail = exports.FetchError = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _graphql = require('graphql');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// An error which occurs when making a request fails.
var FetchError = exports.FetchError = function (_GraphQLError) {
  (0, _inherits3.default)(FetchError, _GraphQLError);

  function FetchError(resp, body) {
    (0, _classCallCheck3.default)(this, FetchError);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FetchError.__proto__ || (0, _getPrototypeOf2.default)(FetchError)).call(this, 'Request Failed. Status: ' + resp.status + ' - ' + resp.statusText + '. Body: ' + body));

    _this.body = body;
    _this.resp = resp;
    return _this;
  }

  return FetchError;
}(_graphql.GraphQLError);

var throwOnFail = exports.throwOnFail = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resp) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!resp.ok) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return', resp);

          case 4:
            _context.t0 = FetchError;
            _context.t1 = resp;
            _context.next = 8;
            return resp.text();

          case 8:
            _context.t2 = _context.sent;
            throw new _context.t0(_context.t1, _context.t2);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function throwOnFail(_x) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/errors.js
// module id = 547
// module chunks = 0